import { Box } from '@mui/material';
import { CoverageForm } from '@screens/plans/form/CoverageForm';
import { HeaderPlans } from '@screens/plans/HeaderPlans';
import { Toats } from '@components/alerts/Toats';
import { useChangePrice } from '@hooks/useChangePrice';
import React, { useState, useEffect } from 'react';
import { Wrapper } from '@screens/plans/Wrapper';
import { useDriverStore } from '@store/driverInfoStore';
import { useHistory } from 'react-router-dom';
import { useCPStore } from '@store/cpStore';
import { useTokenStore } from '@store/TokenStore';
import DraggableFab from '@buttons/DraggableFab';

import { useCarStore } from '@store/carInfoStore';
import { usePolicyStore } from '@store/policyStore';
import { upCRMContact } from '@utils/CRM';
import { useTrackingStore } from '@store/TrackingStore';
import { useSelectedQuoteStore } from '@store/QuoteStore';
import axios from 'axios';
import { NameSubstring } from '@utils/utilityFunctions';

type ModalHomeProps = {
  onClose: () => void;
};

export const Plans: React.FC<ModalHomeProps> = () => {
  const { car } = useCarStore();
  const { policy, addPolicyInfo } = usePolicyStore();
  const { tracking } = useTrackingStore();
  const { selectedQuote } = useSelectedQuoteStore();
  const [url, setUrl] = useState<any>('');

  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const [coverage, setCoverage] = useState<string>('Plan amplio');
  const [showToast, setShowToast] = useState(true);
  const { searchCP, cpData } = useCPStore();
  const history = useHistory();
  const { token } = useTokenStore();
  const { driver } = useDriverStore();
  const [zip, setZip] = useState<string>(driver.codigoPostal || '');

  useEffect(() => {
    if (window.location.pathname === '/plans') {
      // Create and append the element again
      const newWidgetElement = document.createElement('div');
      newWidgetElement.id = 'twilio-webchat-widget-root';
      document.body.appendChild(newWidgetElement);
      const appConfig = {
        deploymentKey: 'CVa7674a31522f9f7b440d153907bdd779',
        serverUrl: 'https://demos2.inter.mx/twilio-webchat'
      };

      setTimeout(() => {
        const targetElement = document.querySelector(
          '.css-wonh0e'
        ) as HTMLElement;

        if (targetElement) {
          targetElement.style.zIndex = '1000';
        }
      }, 100);

      // Assuming Twilio is available globally, you may need to import it or access it differently
      // @ts-ignore
      Twilio.initWebchat(appConfig);
    }
    return () => {
      document.getElementById('twilio-webchat-widget-root')?.remove();
    };
  }, []);

  useEffect(() => {
    window.scroll(0, 0);
    getIp();
    (async () => {
      let date = new Date();
      let day = `${date.getDate()}`.padStart(2, '0');
      let month = `${date.getMonth() + 1}`.padStart(2, '0');
      let year = date.getFullYear();
      let fechaHoy = `${year}-${month}-${day}`;
      if (selectedQuote?.vehicle?.type === 'MOTO') {
        await addPolicyInfo({ ...policy, start_at: fechaHoy, customDM: '10', customRT: '20' });
      } else {
        await addPolicyInfo({ ...policy, start_at: fechaHoy, customDM: '5', customRT: '10' });
      }
    })();
    searchCP(zip, token);
  }, []);

  const getIp = async () => {
    if (policy.ipInicio === '') {
      const res = await axios.get('https://api.ipify.org/?format=json');
      policy.ipInicio = res.data.ip;
      await addPolicyInfo({ ...policy });
    }
  };

  useChangePrice();

  if (driver.codigoPostal === '') {
    history.push('/options');
  }

  const sendApi = async () => {
    try {
      setLoading(true);
      let response = await upCRMContact(
        token,
        car,
        driver,
        selectedQuote,
        policy,
        tracking,
        cpData,
        selectedQuote,
        url
      );
      setTimeout(() => {
        if (response.success) {
          setLoading(false);
          setSuccess(true);
        } else {
          setLoading(false);
        }
      }, 1000);
    } catch (e) {
      setLoading(false);
      setSuccess(true);
    }
  };

  const title = (
    <p style={{ margin: 0 }}>
      Hola 👋 <strong>{NameSubstring(driver.name)}</strong> ¿Necesitas ayuda
      para escoger la mejor opción?
    </p>
  );

  return (
    <Wrapper>
      <Toats
        showToast={showToast}
        setShowToast={setShowToast}
        Text="¡Ojo! Estos precios podrían cambiar. ¡Pero no te preocupes! Te avisaremos siempre que las aseguradoras hagan modificaciones."
        isWarning
      />
      <HeaderPlans />
      <Box marginTop={3}>
        <CoverageForm coverage={coverage} setCoverage={setCoverage} />
      </Box>
      <DraggableFab
        loading={loading}
        success={success}
        action={sendApi}
        title={title}
        isPlans
      />
    </Wrapper>
  );
};
